import * as React from "react";
import { css } from "emotion";
const centeredElementOuterClass = css({
    backgroundImage: "url(https://assets.21real.estate/background.png)",
    backgroundSize: "cover",
    flexGrow: 1,
    position: "relative",
});
function centeredElementInnerClass(x, y) {
    return css({
        position: "absolute",
        left: x.join(""),
        top: y.join(""),
        transform: "translate(-50%, -50%)",
    });
}
export const CenteredElement = (props) => (React.createElement("div", { className: centeredElementOuterClass },
    React.createElement("div", { className: centeredElementInnerClass(props.x ? props.x : [50, "%"], props.y ? props.y : [50, "%"]) }, props.children)));
export default CenteredElement;
//# sourceMappingURL=centeredelement.js.map